<template>
  <div class="animated revealUp">
    <!-- SEND EMAIL MODAL -->
    <!-- <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      ref="sendEmail"
    >
      <h5
        class="font-weight-bold text-blue text-center"
      >Are you sure you want to send this invoice to vendor?</h5>
      <div class="d-flex mx-auto">
        <button
          :disabled="disableYesButton"
          @click.prevent="onClickYes()"
          class="btn-blue"
          title="Yes"
        >Yes</button>
        <button @click.prevent="onClickNo()" class="btn-blue" title="No">No</button>
      </div>
    </b-modal>-->
    <!-- SEND EMAIL MODAL -->

    <!-- <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view')}} {{ $t('purchase') }} {{ $t('order') }}</div>
      <div class="d-flex">
        <button @click.prevent="openConfirmEmailModal()" class="btn-blue" title="Send Email">
          <img src="@/assets/img/icons/email.png" height="auto" width="25" />
        </button>
        <a
          v-if="getPurchaseOrderFileName"
          :href="BASE_URL+getPurchaseOrderFileName"
          target="_blank"
          download
          class="btn-transparent"
          title="Download as PDF"
        >
          <button v-if="getPurchaseOrderFileName" class="btn-blue" title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="auto" width="25" />
          </button>
        </a>
        <router-link
          class="btn-blue mx-2"
          :to="'/fnb/edit-purchase-order?po_number='+purchasOrderDetails.po_number+'&po_id='+purchasOrderDetails.po_id"
        >{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="/fnb/purchase-order"
        >{{ $t('purchase') }} {{ $t('order') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>-->

    <div class="section-title mb-4">{{ "View F&B Transaction" }}</div>
    <div class="white-wrapper">
      <p class="text-heading">F&B Order Details</p>
      
      <div class="table_design">
      
      <table
        v-if="transactionList && transactionList.length > 0"
        border="1"
        style="width:100%;border: none;"
      >
        <tbody
        style="border:none"
        >
          <tr style="vertical-align:top;">
            <td style="padding:5px;display: flex;justify-content: center;" class="border-right-new">
              <tr>
                <strong style="font-size:16px;">Order Code : </strong>
              <span>{{ transactionList[0].order_code }}</span>
              </tr>
             
              <!-- <tr>[City, ST ZIP]</tr> -->
              <!-- <tr>Status : {{ transactionList[0].fat_status }}</tr> -->
              <!-- <tr>Fax: (000) 000-0000</tr> -->
              <!-- <tr>Website:</tr> -->
            </td>
            <td style="padding:5px;" class="border-right-new">
                 <tr class="d-flex justify-content-center">
                <strong>Booking Source : </strong>
                {{
                  transactionList[0].fst_booking_source
                }}
              </tr>
            </td>
            <td style="padding:5px;border:none" class="">
              <tr class="d-flex justify-content-center">
                <strong>{{
                  "Transaction Date"
                }} : </strong>
                {{
                  dateParse(transactionList[0].ft_date_time)
                }}
              </tr>
              <!-- <tr>{{ 'Delivery Date' }}: {{ dateParse(transactionList[0].fnb_delivery_datetime) }}</tr> -->
            </td>
          </tr>
        </tbody>
      </table>
      
      </div>
      <!-- <table border="1" style="width:100%;margin-bottom:50px;">
        <thead style="background:#3876d2; color: white; text-align: center;">
          <tr>
            <th style="width:50%;padding:5px;">VENDOR</th>
            <th style="width:50%;padding:5px;">SHIP TO</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style="padding:5px;"
            >Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum harum iure fuga velit voluptatem officiis reprehenderit voluptatibus omnis, nisi numquam facere excepturi illum, eius architecto eos quisquam quas! Quis, magnam.</td>
            <td style="padding:5px;"></td>
          </tr>
        </tbody>
      </table>-->

      <!-- <table border="1" style="width:100%;margin-bottom:50px;">
        <thead style="background:#3876d2; color: #fff; text-align: center;">
          <tr>
            <th style="padding:5px">REQUISITIONER</th>
            <th style="padding:5px">SHIP VIA</th>
            <th style="padding:5px">F.O.B.</th>
            <th style="padding:5px">SHIPPING TERMS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>-->

      <table
        v-if="transactionList && transactionList.length > 0"
        border="1"
        style="width:100%;margin-bottom:20px;"
      >
        <thead class="bg-lightgrey text-center">
          <tr>
            <th style="padding:5px; text-transform: uppercase;">
              {{ $t("items") }}
            </th>
            <!-- <th style="padding:5px; text-transform: uppercase;">{{ $t('description') }}</th> -->
            <th style="padding:5px; text-transform: uppercase;">QTY</th>
            <!-- <th style="padding:5px; text-transform: uppercase;">UOM</th> -->
            <th style="padding:5px; text-transform: uppercase;">
              {{ $t("unit") }} {{ $tc("price", 1) }}
            </th>
            <th style="padding:5px; text-transform: uppercase;">TOTAL</th>
          </tr>
        </thead>
        <tbody
          v-for="(transaction, transactionKey) in transactionList"
          :key="transactionKey"
          style="text-align:center;"
        >
          <tr>
            <td rowspan="5">{{ transaction.fst_item_name }}
              <span v-if="transaction.hasOwnProperty('combo_data') && transaction.combo_data && transaction.combo_data.length > 0">
               <br> {{transaction.combo_data.map((x) => x.quantity + 'x-' + x.item_name).join(', ')}}
              </span>
            </td>
            <!-- <td>{{ raw.rm_description }}</td> -->
            <td rowspan="5">{{ transaction.fst_quantity }}</td>
            <td class="text-right pr-2">
              {{ currFormat(transaction.fp_amount_before_offer / transaction.fst_quantity) }}
            </td>
            <td class="text-right pr-2">{{ currFormat(transaction.fp_amount_before_offer) }}</td>
            <!-- <td>{{ raw.poi_price }}</td> -->
          </tr>
          <tr>
            <td style="text-transform: uppercase;" class="text-left pl-2">{{ $t("subtotal") }}</td>
            <td style="font-weight:bold;" class="text-right pr-2">
              {{ currFormat(transaction.fp_amount_before_offer) }}
            </td>
          </tr>

          <tr>
            <td style="text-transform: uppercase;" class="text-left pl-2">{{ $t("tax") }}</td>
            <td class="text-right pr-2">
              {{
                currFormat(transaction.fp_total_amount_before_offer - transaction.fp_amount_before_offer)
              }}
            </td>
          </tr>
          <tr>
            <td class="text-left pl-2">
              <strong style="text-transform: uppercase;">TOTAL</strong>
            </td>
            <td class="text-right pr-2">
              <strong
                >{{ transaction.ft_currency_name }}
                {{ currFormat(transaction.fp_total_amount_before_offer) }}</strong
              >
            </td>
          </tr>
        </tbody>
        <tbody >
          <tr>
            <td rowspan="4" colspan="2"></td>
          </tr>
          <tr>
            <td>
              <strong style="text-transform: uppercase;" class="text-left pl-2">Final Total</strong>
            </td>
            <td class="text-right pr-2">
              <strong
                >{{ transactionList[0].ft_currency_name }}
                {{ currFormat(transactionList.reduce(function(accumulator, { fp_total_amount_before_offer }) { return accumulator + parseFloat(fp_total_amount_before_offer); },0)) }}</strong
              >
            </td>
          </tr>
          <tr class="text-success">
            <td>
              <strong style="text-transform: uppercase;" class="text-left pl-2">Discount</strong>
            </td>
            <td class="text-right pr-2">
              <strong
                >-{{ transactionList[0].ft_currency_name }}
                {{ currFormat(transactionList[0].ft_offer_price) }}</strong
              >
            </td>
          </tr>
          <tr>
            <td class="text-left pl-2">
              <strong style="text-transform: uppercase;">Grand Total</strong>
            </td>
            <td class="text-right pr-2">
              <strong
                >{{ transactionList[0].ft_currency_name }}
                {{ currFormat(parseFloat(transactionList[0].ft_total_amount || 0)) }}</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import moment from "moment";
export default {
  data() {
    return {
      transactionList: []
    };
  },
  beforeMount() {},
  mounted() {
    const { ft_id } = this.$route.params;
    console.log("ft_id :>> ", ft_id);
    if (ft_id) {
      this.getTransactionDetails(ft_id);
    }
  },
  methods: {
    dateParse(date) {
      return moment(date).format("DD-MMM-YYYY HH:mm");
    },
    getTransactionDetails(ft_id) {
      //   const { ft_id } = this.$route.params;
      PosFnbService.GetFnBTransactionDetails({
        ft_id: ft_id
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.transactionList = data.Records;
            console.log("this.transactionList :>> ", this.transactionList);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    }
  }
};
</script>

<style scoped>
.text-heading{
  font-size: 22px;
  font-weight: bold;
}
.table_design{
  border: 1px solid #3876d2;
  background-color: white;
  padding: 0px;
  border-radius: 10px;
  margin-bottom:30px;
}
.border-right-new{
  border-right: 1px solid blue;
  border-top: none;
  border-bottom: none;
  border-left:none ;
 
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnbtransactionComponents/viewFnBTransaction.vue